import { jsx } from "react/jsx-runtime";
import { forwardRef, useCallback } from "react";
import { ButtonIcon } from "../../ButtonIcon/ButtonIcon.mjs";
const FieldButtonIcon = forwardRef(
  ({ label, onClick, onMouseDown, ...restProps }, forwardedRef) => {
    const handleMouseDown = useCallback(
      (event) => {
        if (typeof onMouseDown !== "function") {
          return;
        }
        if (!onClick) {
          event.preventDefault();
        }
        onMouseDown(event);
      },
      [onClick, onMouseDown]
    );
    return /* @__PURE__ */ jsx(
      ButtonIcon,
      {
        ref: forwardedRef,
        label,
        tone: "secondary",
        variant: "transparent",
        onClick,
        onMouseDown: handleMouseDown,
        tabIndex: -1,
        ...restProps
      }
    );
  }
);
FieldButtonIcon.displayName = "FieldButtonIcon";
export {
  FieldButtonIcon
};
